import styles from "./SignUpModal.module.css";
import { useState, ChangeEvent } from "react";

/**
 * @author kmy
 * @date 2025-03-24
 * @remark 모두의 지도 서비스 이용약관 동의 모달
 *
 * 이용약관 페이지 생성을 위해 Prop를 모두 옵셔널로 바꾸고 TermsScreen에 연결 | 250804 | smyun
 */

interface PolicyModalProps {
    checkBoxClicked?: (e: ChangeEvent<HTMLInputElement>) => void;
    isAccepted?: boolean;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ checkBoxClicked, isAccepted }) => {
    const [accepted, setAccepted] = useState(isAccepted);
    const clickHandler = (e: ChangeEvent<HTMLInputElement>) => {
        checkBoxClicked && checkBoxClicked(e);
        setAccepted((prevAccepted) => !prevAccepted);
    };

    return (
        <div className={styles.modal_contents}>
            <div className={styles.scroll_bx}>
                <h4>제 1장 총칙</h4>
                <b>제 1 조 (목적)</b>
                <p>
                    본 약관은 한국공간정보통신㈜(이하 “회사”라 함)이 모두의 지도(이하 “모두의 지도”라 함) 서비스를 이용하는 고객(이하 “고객”이라
                    함)에게 제공하는 서비스의 이용과 관련하여 회사와 이용기관 및 개인과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로
                    합니다.
                </p>

                <br />

                <b>제 2 조 (용어의 정의)</b>
                <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
                <p>
                    1) “서비스”라 함은 회사가 제공하는 모두의 지도 웹, 어플리케이션을 통하여 해당 웹, 어플리케이션이 가진 기능을 사용할 수 있도록 하는
                    위치기반 서비스를 의미합니다.
                </p>
                <p>
                    2) “고객”이라 함은 회사가 제공하는 서비스를 받는 제5조 1항에 따라 회원가입을 진행하거나 회원가입을 진행하지 않은 모든 사용자를
                    의미합니다.
                </p>
                <p>
                    3) “회원”이라 함은 모두의 지도에 회원가입을 신청하고 회사로부터 승인받은 사용자로서 모두의 지도에 개인정보를 제공하여 계정 정보를
                    부여받은 자를 의미합니다. 회원은 이용 내역 서비스, 유료 서비스 등을 추가적으로 이용할 수 있습니다.
                </p>
                <p>
                    4) “비회원”이라 함은 회원가입을 하지 않고 모두의 지도가 제공하는 서비스를 이용하는 자를 의미합니다. 기본 서비스만 이용이
                    가능합니다.
                </p>
                <p>5) “계정”이라 함은 회원가입을 진행하여 이용 내역 서비스, 유료 서비스 등을 추가적으로 사용할 수 있게 회원이 부여받는 정보입니다.</p>
                <p>
                    6) “계정 정보”라 함은 모두의 지도를 이용하기 위해 회사가 정한 필수 내지 선택 입력 정보로서 모두의 지도 계정 설정 화면을 통해 정보
                    확인, 변경 처리 등을 관리할 수 있는 회원정보 항목을 의미합니다.
                </p>

                <br />

                <b>제 3 조 (이용약관의 효력 및 변경)</b>
                <p>
                    1) 본 약관의 내용은 모두의 지도 웹, 어플리케이션 또는 개별 서비스의 화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에 동의한
                    고객 모두에게 그 효력이 발생합니다.
                </p>
                <p>
                    2) 회사는 필요한 경우 관련법령을 위배하지 않는 범위 내에서 본 약관을 개정할 수 있습니다. 본 약관이 개정되는 경우 개정 약관의
                    적용일자 및 개정사유를 명시하여 현행 약관과 함께 서비스의 공지사항에 게시하는 방법으로 고객이 사전에 인지할 수 있도록 약관 적용
                    15일 전부터 적용 전일까지 공지합니다. 피치 못하게 고객에게 불리한 내용으로 변경할 경우에는 개정 일자 30일 전부터 고객의 계정
                    정보에 등록된 이메일 주소로 이메일 발송 방법 등으로 개별적으로 공지합니다.
                </p>
                <p>
                    3) 회사는 제3조 2항에 따른 공지 또는 통지일로부터 개정 약관 시행일 7일 후까지 고객이 거부 의사를 표시하지 아니하면 개정 약관의
                    적용에 동의한 것으로 봅니다. 고객이 개정 약관에 동의하지 않는 경우 고객은 개정 약관 적용 전일까지 서비스 회원에서 탈퇴할 수
                    있습니다.
                </p>
                <p>
                    4) 고객이 책임질 수 없는 사정(개정 약관에 관한 공지 기간 동안 서비스에 접속하지 않았다는 사정은 책임질 수 없는 사정에 해당하지
                    않는 것으로 합니다.)으로 전항의 회원 탈퇴 조치를 취하지 못한 경우, 그러한 사정을 입증하여 책임질 수 없는 사정이 소멸한 즉시 회원
                    탈퇴 조치를 취할 수 있습니다.
                </p>

                <br />

                <b>제 4 조 (약관 외 준칙)</b>
                <p>
                    본 약관에 규정되지 않은 사항에 대해서는 관련법령 또는 회사가 정한 개별 서비스의 이용약관, 개인정보취급방침, 운영정책 및 규칙
                    등(이하 “세부지침”이라 함)의 규정에 따릅니다.
                </p>

                <br />

                <h4>제 2장 이용계약</h4>
                <b>제 5 조 (이용계약의 성립 등)</b>
                <p>
                    1) 모두의 지도 계정 이용 신청은 개별 서비스 또는 모두의 지도 웹, 어플리케이션 회원가입을 통해 본 약관에 동의한 후, 고객이 모두의
                    지도 계정 정보에 일정 정보를 입력하여 신청하는 방식으로 이루어집니다.
                </p>
                <p>
                    2) 모두의 지도 계정 이용계약은 고객이 본 약관의 내용에 동의한 후 제5조 제1항에서 정의한 계정 이용 신청을 하면 회사가 입력된 일정
                    정보를 인증한 후 가입을 승낙함으로써 성립합니다.
                </p>

                <br />

                <b>제 6 조 (회원가입)</b>
                <p>유료 서비스를 이용하고자 하는 고객은 당 사이트에서 정한 회원가입 양식에 개인정보를 기재하여 회원가입을 하여야 합니다.</p>

                <br />

                <b>제 7 조 (회원의 아이디 및 비밀번호 관리)</b>
                <p>
                    1) 고객의 아이디와 비밀번호(이하 “식별수단”이라 함)에 관한 관리책임은 고객에게 있으며, 이를 제3자가 이용하도록 하여서는 안됩니다.
                </p>
                <p>2) 고객은 식별수단이 도용되어 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.</p>
                <p>
                    3) 전 항의 규정에도 불구하고 해당 고객이 회사에 그 식별수단의 도용 사실을 통지하지 않거나, 통지한 후 회사의 안내에 따르지 않아
                    고객에게 발생한 불이익에 대하여 회사는 어떠한 책임도 부담하지 않습니다.
                </p>

                <br />

                <b>제 8 조 (회원정보의 변경)</b>
                <p>1) 고객은 개인정보관리화면을 통하여 회원 정보를 언제든지 열람하고 자신의 비밀번호를 수정할 수 있습니다.</p>
                <p>
                    2) 고객은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 회사에 문의 등 기타 방법으로 회사에 대하여 그
                    변경사항을 알려야 합니다.
                </p>
                <p>
                    3) 계정 서비스의 제공 및 관리를 위해 필요한 이메일, 기타 본인확인 정보 등 일부 정보는 수정이 불가능할 수 있으며, 수정하는 경우에는
                    추가적인 본인 확인 절차가 필요할 수 있습니다. 여러분이 이용 신청 시 알려주신 내용에 변동이 있을 때, 직접 수정하시거나 이메일을
                    통하여 회사에 알려 주시기 바랍니다.
                </p>
                <p>4) 제7조 제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.</p>

                <br />

                <b>제 9 조 (계정 이용의 제한)</b>
                <p>
                    1) 제5조에 따른 가입 신청자에게 회사는 원칙적으로 모두의 지도 계정의 이용을 승낙합니다. 다만, 회사는 아래 각 호의 경우에는 그
                    사유가 해소될 때까지 승낙을 유보하거나 승낙하지 않을 수 있습니다. 특히, 고객이 만 14세 미만인 경우에는 부모님 등 법정대리인의
                    동의가 있는 경우에만 모두의 지도 계정을 생성할 수 있습니다.
                </p>
                <p>(1) 회사가 본 약관 또는 세부지침에 의해 고객의 모두의 지도 계정을 삭제하였던 경우</p>
                <p>(2) 고객이 다른 사람의 명의나 이메일 주소 등 개인정보를 도용하여 모두의 지도 계정을 생성하려 한 경우</p>
                <p>(3) 모두의 지도 계정 생성 시 필요한 정보를 입력하지 않거나 허위의 정보를 입력한 경우</p>
                <p>(4) 제공 서비스 설비 용량에 현실적인 여유가 없는 경우</p>
                <p>(5) 서비스 제공을 위한 기술적인 부분에 문제가 있다고 판단되는 경우</p>
                <p>(6) 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우</p>
                <p>(7) 회사로부터 회원 자격 박탈 조치 등을 받은 회원이 그 조치 기간에 이용계약을 임의로 해지하고 재 이용을 신청하는 경우</p>
                <p>(8) 기타 관련법령에 위배되거나 세부지침 등 회사가 정한 기준에 반하는 경우</p>
                <p>
                    2) 만약, 고객이 제8조 1항에 위반하여 모두의 지도 계정을 생성한 것으로 판명된 때에는 회사는 즉시 고객의 모두의 지도 계정 이용을
                    정지시키거나 모두의 지도 계정을 삭제하는 등 회사는 적절한 조치를 취할 수 있습니다.
                </p>

                <br />

                <b>제 10 조 (이용계약 해지)</b>
                <p>
                    1) 고객이 모두의 지도계정 이용을 더 이상 원치 않는 때에는 언제든지 서비스 내 제공되는 메뉴를 이용하여 이용계약의 해지(이하
                    “회원탈퇴”라 함) 신청을 할 수 있으며, 회사는 법령이 정하는 바에 따라 신속히 처리하겠습니다.
                </p>
                <p>
                    2) 고객이 회원탈퇴를 진행하면 법령 및 개인정보 처리방침에 따라 고객의 정보를 보유하는 경우를 제외하고는 고객의 모두의 지도 계정
                    정보로 이용했던 데이터는 삭제됩니다. 다만, 고객이 개별 서비스 내에서 작성한 게시물 등 모든 데이터의 삭제와 관련한 사항은 개별
                    서비스의 약관에 따릅니다.
                </p>
                <p>3) 회원탈퇴된 경우라도 고객은 다시 회사에 대하여 이용계약의 체결을 신청할 수 있습니다.</p>

                <br />

                <h4>제 3장 서비스 이용</h4>
                <b>제 11 조 (서비스 제공)</b>
                <p>1) 회사가 모두의 지도 계정을 소유한 회원들에게 제공하는 서비스 내용은 아래와 같습니다.</p>
                <p>(1) 위치 정보 통합 관리: 서비스 이용을 위해 고객이 입력한 위치 정보를 통합 관리합니다.</p>
                <p>(2) 위치 정보 서비스: 서비스 이용을 위해 고객이 입력한 위치 정보를 텍스트, 이미지 또는 다른 형식으로 서비스합니다.</p>
                <p>
                    (3) 유료 서비스: 회사는 해당 서비스에 명시된 요금을 지불하여 더욱 편리한 기능들을 이용할 수 있는 별도의 유료 서비스(이하 “유료
                    서비스”라 함)를 제공합니다.
                </p>
                <p>(4) 기타 회사가 제공하는 서비스</p>
                <p>
                    2) 회사는 더 나은 서비스의 제공을 위하여 고객에게 서비스의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한
                    정보를 서비스 화면 내에 표시하거나 고객의 이메일로 전송할 수 있습니다. 광고성 정보 전송의 경우에는 사전에 수신에 동의한 경우에만
                    전송합니다.
                </p>

                <br />

                <b>제 12 조 (서비스 이용요금)</b>
                <p>
                    1) 회사가 제공하는 서비스는 기본적으로 무료입니다. 단, 별도의 유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용
                    가능합니다.
                </p>
                <p>
                    2) 회사는 유료 서비스 이용요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수
                    있습니다.
                </p>
                <p>3) 유료 서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.</p>
                <p>4) 회원의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.</p>

                <br />

                <b>제 13 조 (서비스의 변경 및 종료)</b>
                <p>
                    1) 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 다만, 아래 각 호의 경우 모두의 지도 계정 서비스의 전부 또는 일부를
                    제한하거나 중지할 수 있습니다.
                </p>
                <p>(1) 모두의 지도 계정 서비스용 설비의 유지·보수 등을 위한 정기 또는 임시 점검의 경우</p>
                <p>(2) 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 모두의 지도 계정 이용에 지장이 있는 경우</p>
                <p>(3) 관계사와의 계약 종료, 정부의 명령/규제 등 회사의 제반 사정으로 모두의 지도 계정 서비스를 유지할 수 없는 경우</p>
                <p>(4) 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</p>
                <p>2) 제12조 1항에 의거하여 회사는 회원에게 사전 통지 또는 공지함을 원칙으로 하며, 부득이한 경우에는 사후 통지 할 수 있습니다.</p>
                <p>
                    3) 고객에게 중대한 영향을 미치는 서비스의 변경 사항이나 종료는 모두의 지도 계정에 등록된 이메일 주소로 메일 발송 등으로 개별적으로
                    알려야 합니다.
                </p>

                <br />

                <b>제 14 조 (개인정보의 보호)</b>
                <p>
                    고객의 개인정보는 서비스의 원활한 제공을 위하여 고객이 동의한 목적과 범위 내에서만 이용됩니다. 자세한 사항은 개인정보처리방침을
                    참고하여 주십시오.
                </p>

                <br />

                <b>제 4장 계약 당사자의 의무</b>
                <p>제 15 조 (회사의 의무)</p>
                <p>1) 회사는 특별한 사정이 없는 한 회사가 제공하는 서비스를 계속적이고 안정적으로 제공해야 합니다.</p>
                <p>2) 회사는 개인정보 보호를 위해 보안시스템을 구축하며 개인정보 보호정책을 공시하고 준수합니다.</p>
                <p>
                    3) 회사는 서비스의 제공설비를 항상 운용 가능한 상태로 유지보수하며, 설비에 장애가 발생하거나 멸실된 경우 지체없이 이를 수리/복구할
                    수 있도록 최선을 다하여 노력합니다.
                </p>
                <p>
                    4) 고객은 메일을 이용하여 의견을 개진할 수 있습니다. 서비스 이용자 전체에 대한 공지는 7일 이상 메인 페이지에 게시함으로써 효력이
                    발생합니다. 고객에게 중대한 영향을 미치는 사항의 경우에는 모두의 지도 계정에 등록된 이메일 주소로 이메일 발송하는 방법 등으로
                    개별적으로 통지합니다.
                </p>

                <br />

                <b>제 16 조 (회원의 의무)</b>
                <p>1) 고객이 모두의 지도 서비스를 이용할 때 아래 각 호의 행위는 하여서는 안 됩니다.</p>
                <p>
                    (1) 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 회원의 모두의 지도 계정 및 비밀번호를 도용, 부정하게 사용하거나, 다른
                    사람의 명의를 사용하거나 명의자의 허락 없이 문자메시지(SMS) 인증 등을 수행하는 행위
                </p>
                <p>(2) 타인의 명예를 손상시키거나 불이익을 주는 행위</p>
                <p>(3) 게시판 및 문의 메일 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위</p>
                <p>(4) 회사 또는 제3자의 저작권 등 기타 권리를 침해하는 행위</p>
                <p>(5) 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위</p>
                <p>
                    (6) 모두의 지도 서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는
                    유포하는 행위
                </p>
                <p>
                    (7) 모두의 지도 서비스의 운영을 고의로 방해하거나 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신 거부 의사에 반하여
                    광고성 정보 또는 스팸 메일(Spam Mail)을 전송하는 행위
                </p>
                <p>
                    (8) 회사의 동의 없이 서비스 또는 이에 포함된 소프트웨어의 일부를 복사, 수정, 배포, 판매, 양도, 대여, 담보제공하거나 타인에게 그
                    이용을 허락하는 행위와 소프트웨어를 역설계하거나 소스 코드의 추출을 시도하는 등 서비스를 복제, 분해 또는 모방하거나 기타 변형하는
                    행위
                </p>
                <p>(9) 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위</p>
                <p>(10) 다른 회원의 개인정보를 수집, 저장, 공개하는 행위</p>
                <p>(11) 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가할 목적으로 허위의 정보를 유통시키는 행위</p>
                <p>(12) 윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위</p>
                <p>
                    (13) 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의
                    일상적 생활을 방해하는 행위
                </p>
                <p>(14) 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위</p>
                <p>
                    (15) 회사 또는 관계사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 E-mail 등을 발송하는
                    행위
                </p>
                <p>
                    (16) 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른
                    컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 E-mail 등으로 발송하는 행위
                </p>
                <p>(17) 기타 불법한 행위</p>
                <p>2) 고객은 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도·증여할 수 없으며, 담보로 제공할 수 없습니다.</p>
                <p>
                    3) 고객이 관련 법령, 회사의 모든 약관 또는 정책을 준수하지 않는다면, 회사는 고객의 위반행위 등을 조사할 수 있고, 고객의 서비스
                    이용에 제한을 걸 수 있습니다.
                </p>

                <br />

                <h4>제 5장 손해배상 및 기타사항</h4>
                <b>제 17 조 (손해배상)</b>
                <p>
                    1) 회사는 법령상 허용되는 한도 내에서 서비스와 관련하여 본 약관에 명시되지 않은 어떠한 구체적인 사항에 대한 약정이나 보증을 하지
                    않습니다. 또한, 회사는 CP(Contents Provider)가 제공하거나 회원이 작성하는 등의 방법으로 서비스에 게재된 정보, 자료, 사실의 신뢰도,
                    정확성 등에 대해서는 보증을 하지 않으며, 회사의 과실 없이 발생된 고객의 손해에 대하여는 책임을 부담하지 아니합니다.
                </p>
                <p>
                    2) 회사는 회사의 과실로 인하여 고객이 손해를 입게 될 경우 본 약관 및 관련 법령에 따라 고객의 손해를 배상하겠습니다. 다만 회사는
                    회사의 과실 없이 발생된 아래와 같은 손해에 대해서는 책임을 부담하지 않습니다. 또한 회사는 법률상 허용되는 한도 내에서 간접 손해,
                    특별 손해, 결과적 손해, 징계적 손해, 및 징벌적 손해에 대한 책임을 부담하지 않습니다.
                </p>
                <p>(1) 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해</p>
                <p>(2) 고객의 귀책사유로 서비스 이용에 장애가 발생한 경우</p>
                <p>(3) 서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해</p>
                <p>(4) 제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써 발생하는 손해</p>
                <p>(5) 제3자가 회사 서버에 대한 전송 또는 회사 서버로부터의 전송을 방해함으로써 발생하는 손해</p>
                <p>(6) 제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해</p>
                <p>(7) 전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등 제3자가 서비스를 이용하는 과정에서 발생된 손해</p>
                <p>(8) 기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해</p>

                <br />

                <b>제 18 조 (면책조항)</b>
                <p>1) 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p>
                <p>2) 회사는 고객의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</p>
                <p>3) 회사는 고객이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</p>
                <p>4) 회사는 고객 상호간 또는 고객과 제3자 간에 서비스를 매개로 하여 발생한 분쟁 등에 대하여 책임을 지지 않습니다.</p>

                <br />

                <b>제 19 조 (분쟁의 해결)</b>
                <p>
                    본 약관 또는 서비스는 대한민국법령에 의하여 규정되고 이행됩니다. 서비스 이용과 관련하여 회사와 고객 간에 분쟁이 발생하면 이의
                    해결을 위해 성실히 협의할 것입니다. 그럼에도 불구하고 해결되지 않으면 민사소송법상의 관할법원에 소를 제기할 수 있습니다.
                </p>

                <br />

                <b>제 20 조 (기타)</b>
                <p>본 약관에서 정하지 않은 사항 및 내용 해석상의 이견이 있을 경우에는 일반상관습에 따르기로 합니다.</p>

                <br />

                <p>[부칙]</p>
                <p>본 약관은 2021년 8월 10일부터 시행합니다.</p>
            </div>
            {isAccepted !== undefined && (
                <div className={`${styles.accept_container} ${styles.row}`}>
                    <label>
                        <input type="checkbox" name="policyAccepted" onChange={clickHandler} checked={accepted} />위 약관의 내용을 숙지했으며, 이에
                        동의합니다.
                    </label>
                </div>
            )}
        </div>
    );
};

export default PolicyModal;
